import { FC, memo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import cn from 'classnames';
import { appRoutes } from 'constants/routes';
import { useAppDispatch } from 'hooks';
import { ReactComponent as Copy } from 'images/newIcons/copy.svg';
import { ReactComponent as Down } from 'images/newIcons/down.svg';
import { ReactComponent as OnMap } from 'images/newIcons/objectActive.svg';
import { DocCoordinates } from 'interfaces/documents';
import { documentCoordinatesActions } from 'store/slices/mapV2/mapReducer/toolsReducer/documentCoordinateSlice';

import { copyToClipboard } from 'utils';

interface DocumentCoordinatesProps {
  coordinates: DocCoordinates[];
}

const DocumentCoordinates: FC<DocumentCoordinatesProps> = ({ coordinates }) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [isExpand, setExpand] = useState(false);

  const handleShowOnMap = (coordinates: DocCoordinates[]) => {
    dispatch(documentCoordinatesActions.setCoordinates(coordinates));
    navigate(appRoutes.MAP);
  };

  const handleCopyCoordinate = (coordinate: string) =>
    copyToClipboard(coordinate);

  return (
    <div className=" ">
      <div className="flex justify-between items-center h-[16px] bg-light p-4">
        <div className="flex items-center">
          <Down
            onClick={() => setExpand((prev) => !prev)}
            className={cn(
              'icon-container cursor-pointer transition-transform',
              { 'rotate-180': isExpand }
            )}
          />
          <span className="tpg-c2 text-tpg_base pl-2">
            Обнаружено {coordinates.length} координат
          </span>
        </div>
        <span
          className="tpg-c2 text-main_product hover:text-bright_product cursor-pointer"
          onClick={() => handleShowOnMap(coordinates)}
        >
          Показать на карте
        </span>
      </div>
      {isExpand && (
        <div className="bg-dark max-h-[160px] overflow-auto">
          {coordinates.map((el, idx) => (
            <div
              className="hover:bg-light hover:text-tpg_title py-2 px-4 tpg-c1 text-tpg_base flex justify-between"
              key={`coordinate-${idx}`}
            >
              <div>{el.title}</div>
              <div className="flex items-center min-w-[200px] justify-between">
                <Copy
                  width={20}
                  height={20}
                  onClick={() =>
                    handleCopyCoordinate(el.coordinates.join(', '))
                  }
                  className="cursor-pointer"
                />
                <div>{el.coordinates.join(', ')}</div>
                <OnMap
                  width={20}
                  height={20}
                  onClick={() => handleShowOnMap([el])}
                  className="cursor-pointer"
                />
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default memo(DocumentCoordinates);
